import React from 'react';
import TrendingPanel from '../../shared/trending-panel';
import SidebarContext from './sidebar-context';

export default function Trending() {
  const { trending } = React.useContext(SidebarContext);
  return <TrendingPanel trending={trending} classNames="sidebar-item sidebar-trending" />;
}
